// extracted by mini-css-extract-plugin
export var option = "_5h-0";
export var optionCard = "_5h-f";
export var optionContent = "_5h-g";
export var optionIcon = "_5h-i";
export var optionIconBox = "_5h-h";
export var optionLabel = "_5h-j";
export var optionPill = "_5h-m";
export var optionPillBadge = "_5h-p";
export var optionPillIcon = "_5h-n";
export var optionPillLabel = "_5h-o";
export var optionRadio = "_5h-k";
export var optionRadioInner = "_5h-l";
export var optionReveal = "_5h-2";
export var optionRevealDelay0 = "_5h-3";
export var optionRevealDelay1 = "_5h-4";
export var optionRevealDelay10 = "_5h-d";
export var optionRevealDelay11 = "_5h-e";
export var optionRevealDelay2 = "_5h-5";
export var optionRevealDelay3 = "_5h-6";
export var optionRevealDelay4 = "_5h-7";
export var optionRevealDelay5 = "_5h-8";
export var optionRevealDelay6 = "_5h-9";
export var optionRevealDelay7 = "_5h-a";
export var optionRevealDelay8 = "_5h-b";
export var optionRevealDelay9 = "_5h-c";
export var optionSelected = "_5h-1";